import { MOKA_GOAUTH_SERVICE } from '../constants';

export const ORDER_REPORTING_SERVICE = `${MOKA_GOAUTH_SERVICE}/order-reporting`;

export const GET_ORDERS = `${ORDER_REPORTING_SERVICE}/backoffice/v1/orders`;
export const GET_INVOICES = `${ORDER_REPORTING_SERVICE}/backoffice/v1/invoices`;
export const getOrderDetailUrl = (id: string) =>
  `${ORDER_REPORTING_SERVICE}/backoffice/v1/orders/${id}`;
